export async function detect404() {
    try {
        const response = await fetch(window.location.href, { method: "HEAD" });

        if (response.status === 404) {
            const header = document.getElementById("header");
            const body = document.querySelector("body");

            if (header) {
                header.style.display = "none";
            }

            if (body) {
                body.style.background = "#fefdfb"
            }
        }
    } catch (error) {
        console.error("Error al verificar el estado 404:", error);
    }
}